import {
  AuthState,
  AuthActionTypes,
  LOGIN,
  LOGOUT,
  APPCRASH,
  SET_DEBUG,
} from './Types';
import {TokenService} from '../../Services/TokenService';
import {OfficeCompanionService} from '../../Services/OfficeCompanionService';
import {ArticleService} from '../../Services/ArticleService';
import {AuthorService} from '../../Services/AuthorService';
import {CategoryService} from '../../Services/CategoryService';
import {HomeService} from '../../Services/HomeService';
import {SurveyService} from '../../Services/SurveyService';
import {UserService} from '../../Services/UserService';
import {DashboardService} from '../../Services/DashboardService';
import {ExceptionService} from '../../Services/ExceptionService';
import {ImageService} from '../../Services/ImageService';
import {MetricService} from '../../Services/MetricService';
import {RoadmapService} from '../../Services/RoadmapService';
import {TicketService} from '../../Services/TicketService';

const initialState: AuthState = {
  clientCode: '',
  token: {
    accessToken: '',
    refreshToken: '',
    expiration: new Date(),
  },
  admin: false,
  appCrash: false,
  debug: false,

  tokenService: new TokenService(),
  officeCompanionService: new OfficeCompanionService(),

  authorised: false,
  articleService: new ArticleService(),
  authorService: new AuthorService(),
  categoryService: new CategoryService(),
  homeService: new HomeService(),
  surveyService: new SurveyService(),
  userService: new UserService(),
  dashboardService: new DashboardService(),
  exceptionService: new ExceptionService(),
  imageService: new ImageService(),
  metricService: new MetricService(),
  roadmapService: new RoadmapService(),
  ticketService: new TicketService(),
};

export const authReducer = (state = initialState, action: AuthActionTypes): AuthState => {
  switch (action.type) {
  case LOGIN: {
    const {clientCode, token} = action.payload;
    return {
      ...state,
      clientCode,
      token,
      admin: clientCode === 'ADMIN',
      authorised: true,
      appCrash: false,
    };
  }
  case LOGOUT:
    return {
      ...initialState,
      debug: state.debug,
    };
  case APPCRASH:
    return {
      ...state,
      appCrash: true,
    };
  case SET_DEBUG:
    return {
      ...state,
      debug: action.payload,
    };
  default:
    return state;
  }
};
